import { CLASS_CONSTATNTS as TYPES } from '../../organizedByType/actions/analyticsActions'
import { isMenuOpen } from './menu.selectors'

export const TOGGLE_MENU = '[menu] toggle menu'
export function toggleMenuAction() {
  return {
    type: TOGGLE_MENU,
  }
}

function sendMenuButtonClickAnalyticsAction(action) {
  return {
    type: TYPES.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Navigation mobile',
        action: `hamburger menu ${action ? 'open' : 'close'}`,
        label: 'none',
      },
    },
  }
}

export const toggleMenu = () => (dispatch, getState) => {
  dispatch(toggleMenuAction())
  dispatch(sendMenuButtonClickAnalyticsAction(isMenuOpen(getState())))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/menu/menu.actions.js